export default __webpack_public_path__ + "static/media/offerdashboard.c3fbd813.svg";